// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Atom_Icon = require("../Atom_Icon.bs.js");
var Atom_Text = require("../Atom_Text.bs.js");
var Particle_Screen_Ds = require("../../particle/Particle_Screen_Ds.bs.js");

var icons = [
  "Envelope",
  {
    NAME: "Checked",
    VAL: "Success"
  },
  "MapMarker",
  "Calendar"
];

function Atom_Icon_Mona(Props) {
  var icon = Props.icon;
  var size = Props.size;
  var title = Props.title;
  var renderScreenreader = title !== undefined ? React.createElement(Atom_Text.ScreenreadersLabel.make, {
          children: title
        }) : null;
  var dsSize = size !== undefined ? Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, size) : Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S");
  return React.createElement(React.Fragment, undefined, React.createElement(Atom_Icon.make, {
                  icon: icon,
                  size: dsSize
                }), renderScreenreader);
}

var make = Atom_Icon_Mona;

exports.icons = icons;
exports.make = make;
/* react Not a pure module */
